export default __webpack_public_path__ + "static/media/wondering-big.eaa1f69a.svg";